let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lHcdb")).then(() => parcelRequire('63U6R'));